export var AlignMap;

(function (AlignMap) {
  AlignMap["auto"] = "auto";
  AlignMap["baseline"] = "baseline";
  AlignMap["center"] = "center";
  AlignMap["end"] = "flex-end";
  AlignMap["start"] = "flex-start";
  AlignMap["stretch"] = "stretch";
})(AlignMap || (AlignMap = {}));

export var align = ['auto', 'baseline', 'center', 'end', 'start', 'stretch'];
export var grow = ['inherit', 'unset', 'initial'];
export var shrink = ['inherit', 'unset', 'initial'];